require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-a-simple-request-in-support-of-inclusivity.json") })
        }
      }, "path---blog-a-simple-request-in-support-of-inclusivity");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-a-simple-request-in-support-of-inclusivity!./.cache/json/blog-a-simple-request-in-support-of-inclusivity.json
// module id = 580
// module chunks = 231608221292675